import { ETTypeInfos } from "@cervval.js/common-dto/src/dtoModel.service";
import { keys, typeInfos } from "@cervval.js/ts-reflect";
import { UsersElementTypes } from "../users/user.model";
import { HealthCheckDTO, HealthCheckItemDTO, HealthCheckItemTemplateDTO, HealthCheckTemplateDTO } from "./healthCheck.dto";

export type HealthCheckElementTypes = {
    "health_check_templates": HealthCheckTemplateDTO,
    "health_checks": HealthCheckDTO,
    "health_check_item_templates": HealthCheckItemTemplateDTO,
    "health_check_items": HealthCheckItemDTO
}

export type HealthCheckElementTypeNames = keyof HealthCheckElementTypes;
export const HealthCheckElementTypeNames: HealthCheckElementTypeNames[] = keys<HealthCheckElementTypes>();

export const healthCheckTypeInfos: ETTypeInfos<HealthCheckElementTypes, HealthCheckElementTypes & UsersElementTypes> = {
    "health_check_templates": {
        keys: keys<HealthCheckTemplateDTO>(),
        typeInfos: typeInfos<HealthCheckTemplateDTO>(),
        foreignKeys: {
            ownerCompanyId: "companies",
            authorId: "user_profiles"
        }
    },
    "health_check_item_templates": {
        keys: keys<HealthCheckItemTemplateDTO>(),
        typeInfos: typeInfos<HealthCheckItemTemplateDTO>(),
        foreignKeys: {
            templateId: "health_check_templates"
        }
    },
    "health_checks": {
        keys: keys<HealthCheckDTO>(),
        typeInfos: typeInfos<HealthCheckDTO>(),
        foreignKeys: {
            ownerCompanyId: "companies",
            patientId: "user_profiles",
            authorId: "user_profiles"
        },
        archivedField: "archived"
    },
    "health_check_items": {
        keys: keys<HealthCheckItemDTO>(),
        typeInfos: typeInfos<HealthCheckItemDTO>(),
        foreignKeys: {
            healthCheckId: "health_checks"
        },
        archivedField: "archived"
    }
};